<template>
  <div>
    <base-header class="pb-6 bg-light">
      <b-row align-v="center" class="py-4">
        <b-col cols="12" lg="6">
          <h6 class="h2 d-inline-block mb-0 text-dark">RF Reports</h6>
        </b-col>
        <b-col cols="12" lg="6" class="text-right">
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
      </b-row>
      <!-- Card stats -->
      <b-row>
        <b-col xl="12">
          <b-card no-body>
            <b-card-body>
              <b-tabs content-class="mt-3">
                <b-tab title="Search" active>
                  <RfSearch></RfSearch>
                </b-tab>
<!--                <b-tab title="Graph">-->
<!--                  <RfGraph></RfGraph>-->
<!--                </b-tab>-->
<!--                <b-tab title="Map">-->
<!--                  <RfMap></RfMap>-->
<!--                </b-tab>-->
              </b-tabs>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </base-header>
    <b-container fluid class="mt--6">
    </b-container>
  </div>
</template>

<script>
  import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb'
  import RfGraph from "./RF-Graph";
  import RfSearch from "./RF-Search";
  import RfMap from "./RF-Map";

  export default {
    name: "RF-Graphing-Dashboard",
    components: {
      RfGraph,
      RfSearch,
      RfMap,
      RouteBreadCrumb,
    },
    mounted() {
      document.title = 'Troubleshooting - RF Graphing';
    },
    methods: {

    }
  }
</script>

<style scoped>

</style>
